// Auth/Social/constants.ts
// apps/SocialOAuth/constants.ts
export const OAUTH_PROVIDERS = {
    GOOGLE: 'google',
    DISCORD: 'discord',
    VK: 'vk',
    YANDEX: 'yandex',
} as const;
